<script>

    import View from '../$layouts/view.layout.svelte'

    import ModalContainer from '../$components/modal.container.svelte'

    import ShipmentModal from './modal.shipment.svelte'
    
    import ShipmentsComponent from './component.shipments.svelte'
    import ShipmentsTracingReportUploadComponent from './component.shipments.tracking.report.upload.svelte'
    import ShipmentsReportComponent from './component.shipments.report.svelte'
    import ShipmentsGuideDownloadComponent from './component.shipments.guide.download.svelte'

    import TitleHero from '../$components/title.hero.svelte'

</script>

<View>
    <div>
        <TitleHero title="Envíos" subtitle="Consulta y gestión de envíos" />
        <ShipmentsComponent />
    </div>
</View>

<ShipmentModal />

<ModalContainer id="shipments_tracing_report_upload_modal" title="Carga de envios en seguimiento" >
    <ShipmentsTracingReportUploadComponent />
</ModalContainer>

<ModalContainer id="shipments_report_modal" title="Reporte de envíos" >
    <ShipmentsReportComponent all={true} />
</ModalContainer>

<ModalContainer id="shipments_download_modal" title="Descarga de guías" >
    <ShipmentsGuideDownloadComponent />
</ModalContainer>